import { NanoEvent } from '@/components/classroom/lib/NanoEvent'

export default class WebPythonWorker extends NanoEvent {
  workerResolve = null
  workerReject = null

  iframeReject (data) {
    if (this.workerReject) this.workerReject(data)
    this.workerResolve = null
    this.workerReject = null
  }

  iframeResolve (data) {
    if (this.workerResolve) this.workerResolve(data)
    this.workerResolve = null
    this.workerReject = null
  }

  constructor (inputfun) {
    super()
    this.worker = null
    this.running = 'init'

    this.inputfun = inputfun
    this.io = {
      output: '',
      error: ''
    }
    this.canvases = {}

    // 以 dataUrls 字符串形式保存的图片，和以 Image 形式保存的图片
    // 其中 Image 的 key 是 filename，dataUrls 的 key 是自增数字字符串
    // Image 的值是 Image 对象，dataUrls 的值是 字符串
    this.assets = {}

    this.counter = 0
    this.mainloop = false
  }

  stop () {
    if (this.running === 'running') {
      this.worker.postMessage({ method: 'interrupt' })
    }
  }

  terminate (message) {
    this.worker && this.worker.terminate()
    if (this.io) {
      if (this.init || !this.io.output) {
        this.io.output = '程序已中止'
      } else if (this.io.output) {
        this.io.output += '\n' + (message || '程序已中止')
      }
    }
    this.running = 'init'
  }

  runOrStop (code) {
    if (this.running === 'running') {
      this.worker.postMessage({ method: 'interrupt' })
    } else {
      this.run(code)
    }
  }

  run (code, io, options) {
    if (!code) return Promise.resolve()
    this.mainloop = false
    this.workerResolve = null
    this.workerReject = null
    if (this.running === 'running') {
      io.error = '上一段代码仍在运行中'
      return Promise.reject(false)
    }
    if (this.worker) {
      this.worker.terminate()
    }
    this.running = 'running'
    this.startAt = Date.now()
    this.skip = false
    this.io = io
    this.init = true
    this.worker = new window.Worker('/static/vendor/skulpt/python_worker.v5.js')
    if (code.indexOf('turtle') > 0) {
      if (!options || !options.target) {
        throw new Error('海龟画布 target 未指定')
      }
      this.target = document.getElementById(options.target)

      if (!this.target) {
        throw new Error('海龟画布 target 未指定')
      }
      this.target.innerHTML = ''
      this.target.setAttribute('tabindex', 0)
      this.target.focus()
    }

    this.counter = 0
    this.canvases = {}

    this.worker.onmessage = async (event) => {
      const messages = event.data
      if (messages.length) {
        for (let i = 0; i < messages.length; i++) {
          await this.parseMessage(messages[i])
        }
      }
    }
    this.worker.postMessage({ method: 'run', code, options })
    return new Promise((resolve, reject) => {
      this.workerResolve = resolve
      this.workerReject = reject
    })
  }

  async parseMessage (message) {
    let canvases = this.canvases

    const method = message.method
    if (method === 'done') {
      if (!this.mainloop) {
        if (this.init) {
          this.io.output = ''
          this.init = false
        }
        this.running = 'done'
        this.iframeResolve()
      }
      return
    }
    if (method === 'error') {
      if (this.init) {
        this.io.output = ''
        this.init = false
      }
      this.running = 'error'
      this.io.error = message.error
      this.iframeReject(true)
      return
    }
    if (method === 'output') {
      if (this.init) {
        this.io.output = ''
        this.init = false
      }
      if (this.skip) return
      if (this.io.output.length > 2000) {
        this.io.output += '......'
        this.skip = true
        return
      }
      // 处理 \r 的情况
      let output = message.output || ''
      output = output.split('\r')
      while (output.length > 1) {
        let o = output.shift()
        this.io.output += o
        let linebreakIndex = this.io.output.lastIndexOf('\n')
        if (linebreakIndex >= 0) {
          this.io.output = this.io.output.substring(0, linebreakIndex + 1)
        } else {
          this.io.output = ''
        }
      }
      this.io.output += output[0]
      return
    }
    if (method === 'interrupt') {
      this.running = 'interrupt'
      return
    }
    if (method === 'assets') {
      // 加载图片资源
      const filename = message.name
      const img = new Image()
      const worker = this
      img.onload = function() {
        worker.assets[filename] = this
        delete message.data
        message.result = {
          filename: filename,
          naturalWidth: img.naturalWidth,
          naturalHeight: img.naturalHeight
        }
        worker.worker.postMessage(message)
      }
      img.onerror = function() {
        delete message.data
        message.result = -1
        worker.worker.postMessage(message)
      }
      img.src = filename
      return
    }
    if (method === 'input') {
      const input = await this.inputfun({
        title: message.title || '',
        type: message.type || 'string',
        prompt: message.prompt,
        default: message.default,
        min: message.min,
        max: message.max
      })
      console.log('getinput', input)
      this.worker.postMessage({ method: 'input', result: input.value, messageId: message.messageId })
      return
    }
    if (method.startsWith('canvas')) {
      switch (method) {
        case 'canvas:create':
          canvases[message.id] = {
            el: document.createElement('canvas')
          }
          canvases[message.id].ctx = canvases[message.id].el.getContext('2d')
          if (message.append) {
            this.target.appendChild(canvases[message.id].el)
          }
          break
        case 'canvas:set': {
          const canvas = canvases[message.id].el
          canvas.width = message.props.width
          canvas.height = message.props.height
          canvas.style.position = message.props.style.position
          canvas.style.display = message.props.style.display
          canvas.style.marginTop = message.props.style.marginTop
          canvas.style.zIndex = message.props.style.zIndex
          canvas.style.transform = message.props.style.transform
          canvas.style.transformOrigin = message.props.style.transformOrigin
          break
        }
        case 'canvas:ctx:call': {
          // 注意这里的消息格式不同
          const data = message.data
          if (data.p === 'hitTest') {
            const pixel = canvases[data.id].ctx.getImageData(...data.args).data
            message.result = pixel[3] || pixel[0] || pixel[1] || pixel[2]
            delete message.data
            this.worker.postMessage(message)
          } else if (data.p === 'drawImage') {
            const imageId = data.args.shift()
            if (typeof this.assets[imageId] === 'string') {
              const image = new Image()
              image.src = this.assets[imageId]
              canvases[data.id].ctx[data.p](image, ...data.args)
            } else if (imageId.filename) {
              canvases[data.id].ctx[data.p](this.assets[imageId.filename], ...data.args)
            }
            delete message.data
            message.result = true
            this.worker.postMessage(message)
          } else if (data.p === 'measureTextWidth') {
            const ret = canvases[data.id].ctx.measureText(...data.args)
            delete message.data
            message.result = ret.width
            this.worker.postMessage(message)
          } else if (data.p === 'toDataURL') {
            const urlId = (this.counter++) + ''
            this.assets[urlId] = canvases[data.id].el.toDataURL()
            delete message.data
            message.result = urlId.toString()
            this.worker.postMessage(message)
          } else {
            canvases[data.id].ctx[data.p](...data.args)
            delete message.data
            message.result = true
            this.worker.postMessage(message)
          }
          break
        }
        case 'canvas:ctx:set':
          canvases[message.id].ctx[message.p] = message.value
          break
        case 'canvas:tourl':
          canvases[message.id].dataUrls[message.url] = canvases[message.id].el.toDataURL()
          break
        case 'target:focus':
          this.target.focus()
          break
        case 'target:blur':
          this.target.blur()
          break
        default:
          break
      }
    }
    if (method.startsWith('turtle')) {
      return this.handleTurtle(message)
    }
    if (method.startsWith('event')) {
      return this.handleEvent(message)
    }
  }

  handleTurtle (message) {
    switch (message.method) {
      case 'turtle:setup':
        this.$emit(message.method, message.data)
        break
    }
  }

  handleEvent (event) {
    const eventName = event.event
    this.target.focus()
    this.mainloop = true
    this.target.addEventListener(eventName, (e) => {
      const rect = this.target.getBoundingClientRect()
      const data = {
        clientX: e.clientX,
        targetLeft: rect.left,
        clientY: e.clientY,
        targetTop: rect.top,
        charCode: e.charCode,
        keyCode: e.keyCode
      }
      e.preventDefault()
      e.stopPropagation()
      this.worker.postMessage({ method: 'event:' + eventName, data })
    })
  }
}
